const properties = {
    buildId: '202610.0',
    contextPath: 'https://rckms.onboard2.aimsplatform.org',
    rsBaseServiceUri: 'https://rckms-mts.authoring.onboard2.aimsplatform.org',
    rsCrudContextPath: '/mts-rs-{0}',
    reportsServiceEndpoint: 'https://rckms-rrs.authoring.onboard2.aimsplatform.org',
};

export default properties;
